import { z } from 'zod'

export const TrainerStatusFilterSchema = z.enum(['all', 'active', 'inactive'])

export const TrainerStatusFilter = TrainerStatusFilterSchema.enum

export type TrainerStatusFilter = z.infer<typeof TrainerStatusFilterSchema>
